
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study",
      function () {
        return require("private-next-pages/case-study/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study"])
      });
    }
  